module.exports = __webpack_public_path__ + "img/mv.373fe0c1.svg";